import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { DangerouslySetInnerHTML } from '@infl-ts/ui-advocate-components';
import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import { PublicResponseStageNames } from '@infl-ts/util-use-challenge-player';
import { Box, ButtonGroup, FormHelperText } from '@mui/material';
import { oneLine } from 'common-tags';
import * as A from 'fp-ts/Array';
import { pipe } from 'fp-ts/function';
import { Translation } from 'react-i18next';
import PointsForCompletion from './points-for-completion';
import ProspectCard from './prospect-card';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var isPublicResponseStage = function isPublicResponseStage(s) {
  return PublicResponseStageNames.is(s.__typename);
};

var PublicResponseHelperText = function PublicResponseHelperText(props) {
  return /*#__PURE__*/_jsx(FormHelperText, _objectSpread(_objectSpread({}, props), {}, {
    "data-element": "FormHelperText",
    "data-component": "PublicResponseHelperText",
    "data-source-file": "stage-layout.tsx"
  }));
};

var StageLayout = function StageLayout(_ref) {
  var _stage$questions;

  var stage = _ref.stage,
      children = _ref.children,
      actions = _ref.actions,
      _ref$showPublicRespon = _ref.showPublicResponseMessage,
      showPublicResponseMessage = _ref$showPublicRespon === void 0 ? false : _ref$showPublicRespon,
      _ref$hidePoints = _ref.hidePoints,
      hidePoints = _ref$hidePoints === void 0 ? false : _ref$hidePoints,
      actionsSx = _ref.actionsSx,
      prospect = _ref.prospect;
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      width: 1,
      mb: 2
    },
    "data-element": "Box",
    "data-component": "StageLayout",
    "data-source-file": "stage-layout.tsx",
    children: [!hidePoints && /*#__PURE__*/_jsx(PointsForCompletion, {
      points: stage.points
    }), stage.description && /*#__PURE__*/_jsx(DangerouslySetInnerHTML, {
      sx: {
        mb: prospect || children ? 4 : 0
      },
      body: stage.description
    }), prospect && prospect.name ? /*#__PURE__*/_jsx(ProspectCard, {
      sx: {
        mb: children ? 4 : 0
      },
      prospect: prospect
    }) : null, children, showPublicResponseMessage && pipe({
      isPublicResponseStage: isPublicResponseStage(stage) && stage.responsesArePublic,
      hasPublicQuestions: stage.__typename === 'QuestionsStage' && pipe((_stage$questions = stage.questions) !== null && _stage$questions !== void 0 ? _stage$questions : [], A.some(function (q) {
        return q.responseIsPublic;
      }))
    }, function (_ref2) {
      var isPublicResponseStage = _ref2.isPublicResponseStage,
          hasPublicQuestions = _ref2.hasPublicQuestions;
      return /*#__PURE__*/_jsx(PublicResponseHelperText, {
        sx: {
          mt: 3
        },
        className: oneLine(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            ", "\n            ", "\n            "])), isPublicResponseStage ? 'publicResponseStage' : '', hasPublicQuestions ? 'hasPublicQuestions' : 'noPublicQuestions'),
        children: /*#__PURE__*/_jsx(Translation, {
          children: function children(t) {
            return isPublicResponseStage ? t('Your responses will be visible to other members.') : hasPublicQuestions ? t('Your responses won’t be visible to other members except those labelled.') : t("Your responses won't be visible to other members.");
          }
        })
      });
    }), actions ? /*#__PURE__*/_jsx(ButtonGroup, {
      sx: mergeSxProps({
        mt: 4,
        width: 1
      }, actionsSx),
      children: actions
    }) : null]
  });
};

export default StageLayout;